
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/radio.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-radio-demo-basic","docs-weet-radio-demo-disable","docs-weet-radio-demo-layout","docs-weet-radio-demo-button","docs-weet-radio-demo-card"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/radio.md?type=demo')
};